import React from "react";
import "containers/Account/Onboarding/Onboarding.css";
import AxiosConfig from "axiosConfig";

class ProfilePicture extends React.Component {
    state = {
        profilePic: "",
        aboutMe: "",
        favoriteThing: "",
    };

    componentDidMount() {
        AxiosConfig.get("/profile/details/profile-picture/")
            .then((res) => {
            this.setState({
                profilePic: res.data.profile_pic
            });
        })
        .catch(err => {
         
        });
    }

    render() {
        return (

            <div>
                <div className="onboarding_content">
                    <div
                        style={{
                            width: "fit-content",
                            align: "center",
                            margin: "auto",
                        }}
                    >
                        {/* <img src={this.state.profilePic}/> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default ProfilePicture;
